import { useTranslation } from 'react-i18next';

import car from '@/assets/images/perfect-transfer/perfect-transfer-car.webp';
import carMobile from '@/assets/images/perfect-transfer/perfect-transfer-car-360.webp';

import { useModal } from '@/hooks/useModal';
import { useScreenType } from '@/hooks/useScreenType';

import { Title } from '@/components/Title';
import { Button } from '@/components/Button';

import styles from './PerfectTransfer.module.scss';

export function PerfectTransfer() {
  const { t } = useTranslation('perfectTransfer');
  const { openModal } = useModal();
  const { screenType } = useScreenType();

  const handleOrderClick = () => {
    openModal('order');
  };

  const handleConsultClick = () => {
    openModal('consult');
  };

  return (
    <section className={styles.perfectTransfer}>
      <div className={styles.perfectTransfer__image}>
        <img src={screenType === 'mobile' ? carMobile : car} alt="GLS" loading="lazy" />
      </div>
      <div className={styles.perfectTransfer__content}>
        <div className={styles.perfectTransfer__info}>
          <Title className={styles.perfectTransfer__title}>{t('title')}</Title>
          <p className={styles.perfectTransfer__description}>{t('description')}</p>
        </div>
        <div className={styles.perfectTransfer__buttons}>
          <Button className={styles.perfectTransfer__button} onClick={handleOrderClick}>
            {t('orderButton')}
          </Button>
          <Button
            className={styles.perfectTransfer__button}
            color="tertiary"
            onClick={handleConsultClick}
          >
            {t('consultButton')}
          </Button>
        </div>
      </div>
    </section>
  );
}
